import React, { Component, Fragment } from "react";
import ConfirmButton from "./../../../components/buttons/ConfirmButton";
import Modal from "./../../../components/modalComponent/ModalComponent";
import ImportFormContainer from "../../ImportFormContainer";
class ImportUser extends Component {
  state = { showModal: false };
  render() {
    return (
      <Fragment>
        <Modal
          title="Importer les profils"
          showModal={this.state.showModal}
          closeModal={() => this.setState({ showModal: false })}
          {...this.props}
        >
          <div>
            <ImportFormContainer {...this.props} title="profiles" importUri={"profiles"} />
          </div>
        </Modal>
        <ConfirmButton label="Importer les profils" onClick={() => this.setState({ showModal: true })} />
      </Fragment>
    );
  }
}
export default ImportUser;



// WEBPACK FOOTER //
// src/containers/admin/users/ImportUser.js